import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const CurrencyContext = createContext({ currency: "USD" });

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [currency, setCurrency] = useState("USD");

  useEffect(() => {
    if (!user || user === false) { setCurrency("USD"); return; }
    if (user.role === "GLOBAL_ADMIN") {
      // Use platform default
      api.get("/public/billing-config").then(({ data }) => setCurrency(data?.currency || "USD")).catch(() => {});
    } else if (user.company_id) {
      api.get("/companies/me").then(({ data }) => setCurrency(data?.currency || "USD")).catch(() => {});
    }
  }, [user]);

  return <CurrencyContext.Provider value={{ currency }}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  return useContext(CurrencyContext).currency;
}

const SYMBOLS = { USD: "$", EUR: "€", GBP: "£", NGN: "₦", GHS: "₵", KES: "KSh", ZAR: "R" };

export function formatMoney(amount, currency = "USD") {
  if (amount == null || amount === "") return "—";
  const n = Number(amount);
  if (Number.isNaN(n)) return "—";
  const code = (currency || "USD").toUpperCase();
  // Try Intl.NumberFormat (handles known ISO codes)
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency", currency: code, currencyDisplay: "narrowSymbol",
    }).format(n);
  } catch {
    const sym = SYMBOLS[code] || (code + " ");
    return `${sym}${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

export function useMoneyFormatter() {
  const cur = useCurrency();
  return (v) => formatMoney(v, cur);
}
